/**
 * Local SDK stubs for @ingenico/api-sdk-directory-private-local
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpResponse } from 'msw';

export const MOCKED_USER_ORGANIZATION_ID = '88452336-bbc0-4c5a-9a8d-62f9d6617625';
const PERMISSIONS = [
  'apps.version.create',
  'bulk.campaign.delete',
  'bulk.campaign.read',
  'bulk.campaign.write',
  'cfg.assigncfgprf',
  'conf.dynamicGroupDelete',
  'conf.dynamicGroupRead',
  'conf.dynamicGroupWrite',
  'conf.smartFieldCategoryDelete',
  'conf.smartFieldCategoryRead',
  'conf.smartFieldCategoryWrite',
  'conf.smartFieldDelete',
  'conf.smartFieldOverride',
  'conf.smartFieldOverrideDelete',
  'conf.smartFieldOverrideRead',
  'conf.smartFieldOverrideWrite',
  'conf.smartFieldRead',
  'conf.smartFieldWrite',
  'digitalreceipt.receiptRead',
  'digitalreceipt.receiptWrite',
  'dm.appRead',
  'dm.appVersionRead',
  'dm.appVersionWrite',
  'dm.appWrite',
  'dm.catalogShare',
  'dm.artifactDelete',
  'dm.artifactRead',
  'dm.artifactWrite',
  'dm.configModuleDelete',
  'dm.configModuleRead',
  'dm.configModuleWrite',
  'dm.configProfileDelete',
  'dm.configProfileRead',
  'dm.configProfileWrite',
  'dm.deploymentAutomatorRead',
  'dm.deploymentAutomatorWrite',
  'dm.deploymentRequestRead',
  'dm.deploymentRequestUninstallWrite',
  'dm.deploymentRequestWrite',
  'dm.deploymentUnitRead',
  'dm.deviceDiagRead',
  'dm.deviceGeofencingRead',
  'dm.deviceGroupRead',
  'dm.deviceGroupWrite',
  'dm.deviceLogcatRead',
  'dm.deviceLogcatWrite',
  'dm.deviceScreenLockingWrite',
  'dm.deviceStateRead',
  'dm.deviceStateWrite',
  'dm.osRead',
  'dm.osVersionRead',
  'dm.osVersionWrite',
  'dm.osWrite',
  'dm.resourceDelete',
  'dm.resourceRead',
  'dm.resourceWrite',
  'dm.screenShareCreate',
  'dm.systemPackageRead',
  'dm.systemPackageVersionRead',
  'dm.systemPackageVersionWrite',
  'dm.systemPackageWrite',
  'dm.templateDelete',
  'dm.templateRead',
  'dm.templateWrite',
  'log.reportRead',
  'ntf.notificationWebhookDelete',
  'ntf.retryWebhookNotification',
  'ntf.webhookDelete',
  'ntf.webhookRead',
  'ntf.webhookWrite',
  'onb.directClientRead',
  'onb.directClientWrite',
  'portals.clientView',
  'prov.logDevArchive',
  'prov.logDevDelete',
  'prov.logDevRead',
  'prov.logDevSuspend',
  'prov.logDevWrite',
  'prov.merchantDelete',
  'prov.merchantRead',
  'prov.merchantWrite',
  'prov.orgDelete',
  'prov.orgRead',
  'prov.orgWrite',
  'prov.physDevAttachDetach',
  'prov.physDevBlockUnblock',
  'prov.physDevDelete',
  'prov.physDevRead',
  'prov.physDevWrite',
  'prov.storeDelete',
  'prov.storeRead',
  'prov.storeWrite',
  'prov.tagsDelete',
  'prov.tagsDevicesWrite',
  'prov.tagsMerchantsWrite',
  'prov.tagsRead',
  'prov.tagsStoresWrite',
  'prov.tagsWrite',
  'prov.tenantDelete',
  'prov.tenantWrite',
  'rep.readreport',
  'rep.reportRead',
  'rep.reportWrite',
  'sf.fileRead',
  'srv.exescreenshare',
  'svc.serviceConfigurationRead',
  'svc.serviceConfigurationWrite',
  'svc.subscriptionRead',
  'svc.subscriptionWrite',
  'task.add',
  'task.read',
  'task.write',
  'txn.transactionRead',
  'um.groupRead',
  'um.groupWrite',
  'um.rolesRead',
  'um.rolesWrite',
  'um.userDelete',
  'um.userRead',
  'um.userWrite',
];
const mockPagination = { totalResults: 0, startIndex: 0, itemsPerPage: 100 };

export function getCurrentUserV1Handler() {
  return HttpResponse.json({
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    username: 'tenant.user',
    givenName: 'Tenant',
    familyName: 'User',
    email: 'tenant.user@example.com',
    zoneInfo: 'Europe/Paris',
    locale: 'en-US',
    status: 'ACTIVE',
    roles: [{ clientApp: 'm360-portals-m360-tenant', name: 'tenant_admin', description: 'tenant_admin' }],
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    phoneNumber: '+33123456789',
    permissions: PERMISSIONS,
    parent: { id: MOCKED_USER_ORGANIZATION_ID, type: 'tenant' },
    idpSource: 'INTERNAL',
  } as any);
}

export function getTenantUserRolesV1ResponseMock() {
  return { pagination: mockPagination, data: [] } as any;
}

export function getUserV1CustomFactory() {
  return {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    parent: { type: 'tenant', id: 'tenant-parent-id' },
    givenName: 'Tenant',
    familyName: 'User',
    username: 'tenant.user',
    email: 'tenant.user@example.com',
    status: 'ACTIVE',
    zoneInfo: 'Europe/Paris',
    idpSource: 'INTERNAL',
  } as any;
}

export function searchTenantRolesV1CustomHandler() {
  return HttpResponse.json({ pagination: mockPagination, data: [] } as any);
}
